var map = {
	"./amazon-pay.svg": 77874,
	"./apple-pay.svg": 47247,
	"./fontawesome/light/air-conditioner.svg": 60062,
	"./fontawesome/light/align-right.svg": 15773,
	"./fontawesome/light/anchor.svg": 65322,
	"./fontawesome/light/ballot.svg": 5220,
	"./fontawesome/light/barcode-read.svg": 41790,
	"./fontawesome/light/bed-alt.svg": 39533,
	"./fontawesome/light/book-alt.svg": 63915,
	"./fontawesome/light/bookmark.svg": 85597,
	"./fontawesome/light/bus.svg": 58147,
	"./fontawesome/light/calendar-alt.svg": 89184,
	"./fontawesome/light/calendar-check.svg": 15000,
	"./fontawesome/light/car-bus.svg": 40722,
	"./fontawesome/light/carrot.svg": 8269,
	"./fontawesome/light/chess-rook.svg": 24789,
	"./fontawesome/light/chevron-down.svg": 12266,
	"./fontawesome/light/chevron-left.svg": 39992,
	"./fontawesome/light/chevron-right.svg": 56171,
	"./fontawesome/light/chevron-square-down.svg": 83218,
	"./fontawesome/light/chevron-up.svg": 21102,
	"./fontawesome/light/child.svg": 56432,
	"./fontawesome/light/clock.svg": 30031,
	"./fontawesome/light/cocktail.svg": 58041,
	"./fontawesome/light/compass.svg": 49301,
	"./fontawesome/light/diploma.svg": 77291,
	"./fontawesome/light/dog.svg": 78916,
	"./fontawesome/light/dollar-sign.svg": 52009,
	"./fontawesome/light/dove.svg": 46159,
	"./fontawesome/light/eye.svg": 48626,
	"./fontawesome/light/file-alt.svg": 17550,
	"./fontawesome/light/globe-stand.svg": 8755,
	"./fontawesome/light/heartbeat.svg": 75702,
	"./fontawesome/light/hiking.svg": 12189,
	"./fontawesome/light/hotel.svg": 59699,
	"./fontawesome/light/house.svg": 52404,
	"./fontawesome/light/id-card.svg": 78594,
	"./fontawesome/light/image-polaroid.svg": 9352,
	"./fontawesome/light/island-tropical.svg": 51400,
	"./fontawesome/light/language.svg": 86425,
	"./fontawesome/light/leaf.svg": 41811,
	"./fontawesome/light/long-arrow-down.svg": 75738,
	"./fontawesome/light/long-arrow-left.svg": 16978,
	"./fontawesome/light/long-arrow-right.svg": 18162,
	"./fontawesome/light/long-arrow-up.svg": 5896,
	"./fontawesome/light/map-marked.svg": 6237,
	"./fontawesome/light/map-marker-alt.svg": 49059,
	"./fontawesome/light/money-bill-wave.svg": 24018,
	"./fontawesome/light/moon.svg": 14033,
	"./fontawesome/light/parking.svg": 28095,
	"./fontawesome/light/pennant.svg": 83061,
	"./fontawesome/light/plane.svg": 45238,
	"./fontawesome/light/plug.svg": 13993,
	"./fontawesome/light/question-square.svg": 96964,
	"./fontawesome/light/router.svg": 91020,
	"./fontawesome/light/ruler-combined.svg": 32806,
	"./fontawesome/light/shopping-bag.svg": 90054,
	"./fontawesome/light/siren-on.svg": 4142,
	"./fontawesome/light/smoking-ban.svg": 92526,
	"./fontawesome/light/star-exclamation.svg": 18749,
	"./fontawesome/light/star.svg": 64443,
	"./fontawesome/light/sun-cloud.svg": 66001,
	"./fontawesome/light/swatchbook.svg": 76252,
	"./fontawesome/light/swimmer.svg": 66442,
	"./fontawesome/light/ticket-alt.svg": 48878,
	"./fontawesome/light/transporter.svg": 2459,
	"./fontawesome/light/umbrella.svg": 74255,
	"./fontawesome/light/users.svg": 20399,
	"./fontawesome/light/utensils.svg": 60347,
	"./fontawesome/light/weight.svg": 37001,
	"./fontawesome/light/wifi.svg": 46449,
	"./fontawesome/solid/car-bus.svg": 54621,
	"./fontawesome/solid/cocktail.svg": 15451,
	"./fontawesome/solid/diploma.svg": 30986,
	"./fontawesome/solid/dot-circle.svg": 60323,
	"./fontawesome/solid/eye.svg": 96040,
	"./fontawesome/solid/hiking.svg": 49455,
	"./fontawesome/solid/island-tropical.svg": 80802,
	"./fontawesome/solid/map-marker-alt.svg": 37657,
	"./fontawesome/solid/map-marker-check.svg": 39562,
	"./fontawesome/solid/map-marker.svg": 7412,
	"./fontawesome/solid/map-pin.svg": 44925,
	"./fontawesome/solid/moon.svg": 23027,
	"./fontawesome/solid/pennant.svg": 29987,
	"./fontawesome/solid/shopping-bag.svg": 71631,
	"./fontawesome/solid/star.svg": 49285,
	"./fontawesome/solid/ticket-alt.svg": 95666,
	"./fontawesome/solid/utensils.svg": 60001,
	"./google-pay.svg": 41798,
	"./logoipsum/logoipsum-1.svg": 43130,
	"./logoipsum/logoipsum-10.svg": 83381,
	"./logoipsum/logoipsum-11.svg": 4543,
	"./logoipsum/logoipsum-12.svg": 12096,
	"./logoipsum/logoipsum-13.svg": 65994,
	"./logoipsum/logoipsum-14.svg": 92219,
	"./logoipsum/logoipsum-15.svg": 98131,
	"./logoipsum/logoipsum-16.svg": 77317,
	"./logoipsum/logoipsum-2.svg": 21901,
	"./logoipsum/logoipsum-3.svg": 87558,
	"./logoipsum/logoipsum-4.svg": 13838,
	"./logoipsum/logoipsum-5.svg": 98126,
	"./logoipsum/logoipsum-6.svg": 19729,
	"./logoipsum/logoipsum-7.svg": 10761,
	"./logoipsum/logoipsum-8.svg": 12305,
	"./logoipsum/logoipsum-9.svg": 61770,
	"./logos/18app.svg": 50729,
	"./logos/48-ore-basilicata-arte-cultura.svg": 82379,
	"./logos/48-ore-basilicata-luce-paesaggio.svg": 23951,
	"./logos/48-ore-bologna.svg": 16107,
	"./logos/48-ore-brescia.svg": 71704,
	"./logos/48-ore-cagliari.svg": 42843,
	"./logos/48-ore-calabria-arte-contemporanea.svg": 15866,
	"./logos/48-ore-calabria-costa-ionica.svg": 74283,
	"./logos/48-ore-calabria-costa-tirrenica.svg": 58317,
	"./logos/48-ore-calabria-outdoor.svg": 35774,
	"./logos/48-ore-calabria.svg": 88973,
	"./logos/48-ore-capri.svg": 83419,
	"./logos/48-ore-garda.svg": 76390,
	"./logos/48-ore-genova.svg": 37731,
	"./logos/48-ore-gorizia.svg": 18786,
	"./logos/48-ore-palermo.svg": 2902,
	"./logos/48-ore-piemonte.svg": 66697,
	"./logos/48-ore-ravenna.svg": 48650,
	"./logos/48-ore-roma.svg": 72215,
	"./logos/48-ore-slovenia-gourmet.svg": 99379,
	"./logos/48-ore-slovenia.svg": 53961,
	"./logos/48-ore-taranto.svg": 33858,
	"./logos/48-ore-terra-barocca.svg": 13256,
	"./logos/48-ore-torino.svg": 65082,
	"./logos/48-ore.svg": 82123,
	"./logos/best-in-travel-2021-horizontal.svg": 87931,
	"./logos/best-in-travel-2021-primary.svg": 51831,
	"./logos/best-in-travel-2021-stacked.svg": 60547,
	"./logos/cartadocente.svg": 7638,
	"./logos/edt-shop.svg": 23582,
	"./logos/edt.svg": 90312,
	"./logos/italia-on-the-road-live.svg": 5846,
	"./logos/italia-on-the-road.svg": 68966,
	"./logos/lonelyplanet-globe.svg": 61090,
	"./logos/lonelyplanet-shop.svg": 34799,
	"./logos/lonelyplanet-stack.svg": 11681,
	"./logos/lonelyplanet.svg": 74719,
	"./logos/unicredit-neg.svg": 96606,
	"./logos/visit_brescia.svg": 92205,
	"./paypal.svg": 3765,
	"./places/ancient.svg": 66069,
	"./places/backpack.svg": 3815,
	"./places/bear.svg": 33093,
	"./places/brain.svg": 30899,
	"./places/colosseum.svg": 62619,
	"./places/cristo-rei.svg": 77177,
	"./places/cutlery.svg": 92198,
	"./places/dunes.svg": 72154,
	"./places/family.svg": 16469,
	"./places/food-n-drink.svg": 98693,
	"./places/golden-gate.svg": 43840,
	"./places/hot-air-balloon.svg": 2486,
	"./places/india.svg": 20100,
	"./places/island.svg": 68806,
	"./places/lighthouse.svg": 85850,
	"./places/marker.svg": 76978,
	"./places/mask.svg": 77338,
	"./places/maya.svg": 83731,
	"./places/nature.svg": 59294,
	"./places/opera.svg": 24713,
	"./places/party.svg": 32878,
	"./places/pottery.svg": 42357,
	"./places/sandals.svg": 38407,
	"./places/statue-of-liberty.svg": 25020,
	"./places/team.svg": 52936,
	"./places/temple.svg": 78096,
	"./places/toucan.svg": 48709,
	"./places/toys.svg": 55090,
	"./places/truck.svg": 87848,
	"./places/university.svg": 37168,
	"./places/urban.svg": 99729,
	"./postal.svg": 70081,
	"./social/Spotify.svg": 57511,
	"./social/amazon_music.svg": 26021,
	"./social/apple_podcasts.svg": 45862,
	"./social/facebook.svg": 1137,
	"./social/flipboard.svg": 91503,
	"./social/google_podcasts.svg": 63635,
	"./social/instagram.svg": 49270,
	"./social/pinterest.svg": 17504,
	"./social/telegram.svg": 8136,
	"./social/twitter.svg": 60716,
	"./social/whatsapp.svg": 14678,
	"./social/youtube.svg": 68846,
	"./specials/community.svg": 26335,
	"./specials/diversity.svg": 74305,
	"./specials/sustainable.svg": 64689,
	"./ui.svg": 71611,
	"./ui/accept.svg": 92329,
	"./ui/aereo-spinner.svg": 9908,
	"./ui/arrow-bottom-left.svg": 7641,
	"./ui/arrow-bottom-right.svg": 63887,
	"./ui/arrow-top-left.svg": 24916,
	"./ui/arrow-top-right.svg": 13455,
	"./ui/avatar.svg": 13638,
	"./ui/calendar.svg": 73152,
	"./ui/checked.svg": 87194,
	"./ui/chevron-down.svg": 69547,
	"./ui/chevron-left.svg": 86208,
	"./ui/chevron-right.svg": 97922,
	"./ui/chevron-up.svg": 43695,
	"./ui/clock.svg": 49980,
	"./ui/close.svg": 99593,
	"./ui/faux-checked.svg": 84745,
	"./ui/faux-left-arrow.svg": 41501,
	"./ui/faux-right-arrow.svg": 60798,
	"./ui/gallery.svg": 51342,
	"./ui/home.svg": 333,
	"./ui/input-checkbox.svg": 10973,
	"./ui/medal.svg": 4322,
	"./ui/on-air.svg": 42165,
	"./ui/pause.svg": 66690,
	"./ui/pin.svg": 3940,
	"./ui/play-arrow.svg": 62998,
	"./ui/play.svg": 827,
	"./ui/quotation.svg": 81710,
	"./ui/search.svg": 59659,
	"./ui/trophy.svg": 42673,
	"./ui/wallet.svg": 95627,
	"./ui/wreath.svg": 81841,
	"./ui/zoom-in.svg": 66901,
	"./vendor/only4u.svg": 72558,
	"./world-delivery.svg": 27970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58824;